<template>
  <v-container id="how-it-works" class="mb-12">
    <h2 class="my-6 text-center">
      5 easy steps to create your South African will online
    </h2>
    <div class="steps-container">
      <v-col cols="12" md="2" sm="12" class="text-center home-steps">
        <img
          :src="require(`@/assets/${whitelabel.images.homeSteps1}`)"
          alt="step 1"
          class="mb-1"
        />
        <div>
          <h3>Sign up</h3>
          <p class="px-12">On our web or mobile platform.</p>
        </div>
      </v-col>
      <v-col cols="12" md="2" sm="12" class="text-center home-steps">
        <img
          :src="require(`@/assets/${whitelabel.images.homeSteps2}`)"
          alt="step 2"
          class="mb-1"
        />
        <div>
          <h3>Answer questions</h3>
          <p class="px-12">
            Using our guided process with informative text to assist you.
          </p>
        </div>
      </v-col>
      <v-col cols="12" md="2" sm="12" class="text-center home-steps">
        <img
          :src="require(`@/assets/${whitelabel.images.homeSteps3}`)"
          alt="step 3"
          class="mb-1"
        />
        <div>
          <h3>Pay once-off fee,</h3>
          <p class="px-12">
            A <strong>R375 fee</strong> unlocks
            <strong>unlimited edits and downloads</strong> of your will.
          </p>
        </div>
      </v-col>
      <v-col cols="12" md="2" sm="12" class="text-center home-steps">
        <img
          :src="require(`@/assets/${whitelabel.images.homeSteps4}`)"
          alt="step 4"
          class="mb-1"
        />
        <div>
          <h3>Download and print</h3>
          <p class="px-4">Access your completed will anytime.</p>
        </div>
      </v-col>
      <v-col cols="12" md="2" sm="12" class="text-center home-steps">
        <img
          :src="require(`@/assets/${whitelabel.images.homeSteps5}`)"
          alt="step 5"
          class="mb-1"
        />
        <div>
          <h3>Sign it</h3>
          <p class="px-4">Then contact us for safekeeping, if you like.</p>
        </div>
      </v-col>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Steps",
};
</script>

<style scoped lang="scss">
.steps-container {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin: 48px;
}

h2 {
  font-size: 40px;
}

h3 {
  font-size: 18px;
}

.home-steps {
  height: 210px;
  width: 290px;
  min-width: 290px;
  img {
    max-width: 75px;
  }
}
</style>
